function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon_invoice_white");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "icon_invoice_white",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-1",
  stroke: "#FFFFFF",
  points: "7.1728506 25.523804 25.5236396 25.523804 25.5236396 6.3388872 19.6847516 0.5 7.1728506 0.5 7.1895342 13.103655"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Stroke-2",
  stroke: "#FFFFFF",
  points: "19.6845683 0.5 19.6845683 6.3388872 25.5234563 6.3388872"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5097656,10.5092773 L22.187541,10.5092773",
  id: "Stroke-3",
  stroke: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.34375,14.6801758 L22.187398,14.6801758",
  id: "Stroke-4",
  stroke: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.0117188,18.850586 L22.1871138,18.850586",
  id: "Stroke-5",
  stroke: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.7559509,13.0117188 C7.5855412,13.0117188 8.3835568,13.1704541 9.1499987,13.4879246 C9.916441,13.8053952 10.5929661,14.257435 11.1795759,14.8440443 C11.7661848,15.4306534 12.2182245,16.1071787 12.5356951,16.8736206 C12.8531656,17.6400624 13.0119009,18.4380789 13.0119019,19.2676697 C13.0119009,20.09726 12.8531656,20.8952756 12.5356951,21.6617175 C12.2182245,22.4281598 11.7661848,23.1046849 11.1795759,23.6912947 C10.5929661,24.2779036 9.916441,24.7299433 9.1499987,25.0474139 C8.3835568,25.3648844 7.5855412,25.5236197 6.7559509,25.5236207 C5.9263601,25.5236197 5.1283436,25.3648844 4.3619018,25.0474139 C3.5954599,24.7299433 2.9189346,24.2779036 2.3323255,23.6912947 C1.74571621,23.1046849 1.29367638,22.4281598 0.97620583,21.6617175 C0.658735275,20.8952756 0.5,20.09726 0.5,19.2676697 C0.5,18.4380789 0.658735275,17.6400624 0.97620583,16.8736206 C1.29367638,16.1071787 1.74571621,15.4306534 2.3323255,14.8440443 C2.9189346,14.257435 3.5954599,13.8053952 4.3619018,13.4879246 C5.1283436,13.1704541 5.9263601,13.0117188 6.7559509,13.0117188 Z",
  id: "Stroke-6",
  stroke: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.6584205,16.6906012 C8.6584205,16.6906012 7.8326349,15.7480392 6.523056,15.8981822 C6.523056,15.8981822 4.9465551,15.8981822 4.4961271,17.8083322 C4.4961271,17.8083322 3.7620954,20.7110972 5.2885475,22.0790632 C5.2885475,22.0790632 6.3145237,23.0132832 7.8826809,22.3042792 C7.8826809,22.3042792 8.3998403,22.0456962 8.6584196,21.7537532",
  id: "Stroke-7",
  stroke: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.0195313,18.583984 L6.7731019,18.583984",
  id: "Stroke-8",
  stroke: "#FFFFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.0195313,20.352051 L6.7731019,20.352051",
  id: "Stroke-9",
  stroke: "#FFFFFF"
}));

var SvgIconInvoiceWhite = function SvgIconInvoiceWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconInvoiceWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_invoice_white.b7ed2dd7.svg";
export { ForwardRef as ReactComponent };